import { StoreOrderListUrlSortField } from "@saleor/storeOrders/urls";
import { StoreOrderSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: StoreOrderListUrlSortField
  // sortBy: {
  //   direction: OrderDirection.DESC,
  //   field: OrderSortField.CREATION_DATE
  // }
): StoreOrderSortField {
  switch (sort) {
    case StoreOrderListUrlSortField.number:
      return StoreOrderSortField.NUMBER;
    case StoreOrderListUrlSortField.date:
      return StoreOrderSortField.CREATION_DATE;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
